<div class="form-row">
  <div class="form-label">
    {{label}}

    <app-tooltip
      *ngIf="tooltipText"
      class="form-label_tooltip"
      [hasTooltip]="true"
      [text]="tooltipText"
    >
      <i svgIcon [icon]="'info'" [iconSize]="svgIconSizeMod.SMALL"></i>
    </app-tooltip>
  </div>
  <div class="form-control">
    <ng-content></ng-content>
  </div>
</div>
